import { render } from "./InvestigationFinance.vue?vue&type=template&id=597a107b&scoped=true&ts=true"
import script from "./InvestigationFinance.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvestigationFinance.vue?vue&type=script&lang=ts&setup=true"

import "./InvestigationFinance.vue?vue&type=style&index=0&id=597a107b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597a107b"],['__file',"src/pages/investigationFinance/InvestigationFinance.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "597a107b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('597a107b', __exports__)) {
    api.reload('597a107b', __exports__)
  }
  
  module.hot.accept("./InvestigationFinance.vue?vue&type=template&id=597a107b&scoped=true&ts=true", () => {
    api.rerender('597a107b', render)
  })

}


export default __exports__